module.exports = __webpack_public_path__ + "assets/img/12_145.0196d988.jpg";